var _circle, _circle2, _circle3, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgDialogRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 151,
    viewBox: "0 0 154 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 77,
    cy: 75.5,
    r: 70,
    stroke: "#FFD4D6",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.34,
    cx: 77,
    cy: 75.5,
    r: 75,
    stroke: "#FFD4D6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 77,
    cy: 75.5,
    r: 63.5,
    stroke: "#FFD4D6",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 75C16.5 41.8629 43.3629 15 76.5 15C109.637 15 136.5 41.8629 136.5 75C136.5 108.137 109.637 135 76.5 135C43.3629 135 16.5 108.137 16.5 75Z",
    fill: "#F8696E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8457 61.2793C82.8477 53.4082 70.0254 53.4082 62.0273 61.2793C54.1562 69.2773 54.1562 82.0996 62.0273 90.0977C70.0254 97.9688 82.8477 97.9688 90.8457 90.0977L96.5586 95.8105C85.3867 106.855 67.4863 106.855 56.3145 95.8105C45.2695 84.6387 45.2695 66.7383 56.3145 55.5664C67.4863 44.5215 85.3867 44.5215 96.5586 55.5664L103.922 48.2031L106.969 51.25V71.5625H86.6562L83.6094 68.5156L90.8457 61.2793Z",
    fill: "url(#paint0_linear_5660_136687)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5660_136687",
    x1: 80.2812,
    y1: 39.5426,
    x2: 80.2812,
    y2: 108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.488728,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC1C3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgDialogRefresh);
export default __webpack_public_path__ + "static/media/img_dialog_refresh.5f31328b6aa75e92d85af241aade053c.svg";
export { ForwardRef as ReactComponent };